export function getClient() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  if (/windows phone/i.test(ua)) return "windows_phone";
  if (/Win/.test(ua)) return "windows";
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
    return "ipad"; // iPadOS masquerading as macOS
  if (/Mac/.test(ua)) return "macos";
  if (/X11/.test(ua)) return "unix";
  if (/Linux/.test(ua)) return "linux";

  return "unknown";
}

export function getBrowserName() {
  const ua = navigator.userAgent;
  const history = () => console.warn("Wow, that is a really old browser you're using.");

  if (ua.includes("Netscape")) {history(); return "netscape";}
  if (ua.includes("MSN")) {history(); return "msn_explorer";}
  if (ua.includes("OPR") || ua.includes("Opera")) return "opera";
  if (ua.includes("Edg")) return "edge";
  if (ua.includes("Chrome") && !ua.includes("Edg") && !ua.includes("OPR")) return "chrome";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "safari";
  if (ua.includes("Firefox")) return "firefox";
  if (ua.includes("MSIE") || ua.includes("Trident")) return "internet_explorer";

  return "unknown_browser";
}